import { create } from 'zustand';
import type { Actor } from '@prooffleet/contracts';

const DEVICE_KEY = 'pf.deviceId';

/**
 * Идентификатор устройства. По замыслу у водителя одно активное устройство:
 * общий аккаунт на двоих разрушает доказательную цепочку — непонятно,
 * кто фактически осматривал машину.
 */
export function deviceId(): string {
  let id = localStorage.getItem(DEVICE_KEY);
  if (id === null) {
    id = crypto.randomUUID().replaceAll('-', '');
    localStorage.setItem(DEVICE_KEY, id);
  }
  return id;
}

interface SessionState {
  /** Access-токен живёт только в памяти: localStorage читается любым XSS. */
  accessToken: string | null;
  actor: Actor | null;
  policyAcknowledged: boolean;
  setSession: (token: string, actor: Actor) => void;
  setPolicyAcknowledged: (value: boolean) => void;
  clear: () => void;
}

export const useSession = create<SessionState>((set) => ({
  accessToken: null,
  actor: null,
  policyAcknowledged: false,
  setSession: (accessToken, actor) => set({ accessToken, actor }),
  setPolicyAcknowledged: (policyAcknowledged) => set({ policyAcknowledged }),
  clear: () => set({ accessToken: null, actor: null, policyAcknowledged: false }),
}));

export const sessionApi = {
  token: (): string | null => useSession.getState().accessToken,
  set: (token: string, actor: Actor): void => useSession.getState().setSession(token, actor),
  clear: (): void => useSession.getState().clear(),
};
